// extracted by mini-css-extract-plugin
export default {"genericAccordion":"MlrF1EgZMT","title":"DLDEvaJoRP","items":"GwliPKbe2x"};